import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getFleetConfigStatus } from '../../services/DeviceService';
import { FleetConfigStatusResponse } from '../../types/Devices';
import { FeaturesManagement } from '../../../featuresControl';

function useGetFleetConfigStatus(
  fleetId: string,
): UseQueryResult<FleetConfigStatusResponse> {
  return useQuery(
    ['fleet-config-status', fleetId],
    async (): Promise<FleetConfigStatusResponse> => getFleetConfigStatus(fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      keepPreviousData: true,
    },
  );
}

export default useGetFleetConfigStatus;
